import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';
import { dataFileUrl, saveFileUrl } from '../../common/api';
import ActionButtons from '../../common/ActionButtons';
import { Icon } from '../../common/AppShell';
import Loader from '../../common/Loader/Loader';
import '../../index.css';

const Contacts = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    phoneNumber: '',
    address: '',
    scheduleStart: 0,
    scheduleEnd: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${dataFileUrl('contacts')}?t=${Date.now()}`)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        toast.error('Ошибка загрузки данных.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: ['scheduleStart', 'scheduleEnd'].includes(name) ? Number(value) : value,
    }));
  };

  const saveData = () => {
    axios
      .put(saveFileUrl('contacts'), data)
      .then(() => toast.success('Данные успешно обновлены!'))
      .catch((error) => {
        console.error('Error saving data:', error);
        toast.error('Ошибка обновления данных.');
      });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <section className="screen-stack">
      <div className="form-card">
        <div className="form-card-title">
          <Icon name="call" />
          <div>
            <h2>Контакты</h2>
            <p>Публичные данные на сайте</p>
          </div>
        </div>

        <label className="app-field">
          <span>Телефон</span>
          <input
            type="text"
            name="phoneNumber"
            placeholder="Телефон"
            onChange={handleChange}
            value={data.phoneNumber || ''}
            inputMode="numeric"
          />
        </label>

        <label className="app-field">
          <span>Адрес</span>
          <input
            type="text"
            name="address"
            placeholder="Адрес"
            onChange={handleChange}
            value={data.address || ''}
          />
        </label>

        <div className="field-grid">
          <label className="app-field">
            <span>Открытие</span>
            <input
              type="number"
              name="scheduleStart"
              placeholder="Открытие"
              onChange={handleChange}
              value={data.scheduleStart || ''}
              inputMode="numeric"
            />
          </label>
          <label className="app-field">
            <span>Закрытие</span>
            <input
              type="number"
              name="scheduleEnd"
              placeholder="Закрытие"
              onChange={handleChange}
              value={data.scheduleEnd || ''}
              inputMode="numeric"
            />
          </label>
        </div>
      </div>

      <ActionButtons onBack={() => navigate('/more')} onSave={saveData} />
    </section>
  );
};

export default Contacts;
